import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService, CreatorFrontApi } from '../../services/component.service';
import { ActivatedRoute } from '@angular/router';
import { OverlayService } from '../../services/overlay.service';
import { BaseChartDirective } from 'ng2-charts';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';
import { DatePipe } from '@angular/common';
import { ChartsService } from '../../services/charts.service';
import { forkJoin, Subscription } from 'rxjs';
import { MaintenanceService } from '../../services/maintenance.service';

@Component({
	selector: 'app-component-report',
	templateUrl: './component-report.component.html',
	styleUrls: ['./component-report.component.scss'],
	providers: [DatePipe]
})
export class ComponentReportComponent implements OnInit, OnDestroy {
	@ViewChild(BaseChartDirective, { static: true }) chart: BaseChartDirective;
	showOpens = true;
	showClicks = true;
	componentData;
	reportData: any = {};
	surveyData: any = {};
	surveyTotalResponses;
	maxSurveyResponses = 500000;
	componentID;
	fromDate;
	toDate;
	dpid: string;
	opensData = [];
	clicksData = [];
	hideTable = true;
	generatingPDF = false;
	pdfBTNText = String(`Export to PDF`);
	generatingSurveyCSV = false;
	surveyCSVButtonText = String(`Export Individual Responses To CSV`);
	generatingCodesCSV = false;
	couponCSVButtonText = String(`Download Assigned Coupons To CSV`);
	barcodesCSVButtonText = String(`Download Assigned Barcodes To CSV`);
	codesCSVButtonText = '';
	isReportDataEmpty = Boolean(false);
	createdTime;
	modifiedTime;
	noResultsError = 'No results found for this query! Please change the filter parameters.';

	geoChart = {
		mapHeight: (550 / 800) * (window.innerWidth * 0.7),
		mapType: 'us_aea',
		colors: ['#adc9ff', '#8399c4'],
		dataType: 'Opens',
		data: {}
	};

	geotableData = [];

	lineChartData = [
		{ data: [], label: 'Opens', yAxisID: 'y-axis-1' },
		{ data: [], label: 'Clicks', yAxisID: 'y-axis-2' }
	];

	engagementChartData = [
		{
			data: [
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null
			],
			label: 'Glanced or Unread'
		},
		{
			data: [
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null
			],
			label: 'Skimmed'
		},
		{
			data: [
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null,
				null
			],
			label: 'Read'
		}
	];

	engagementChartOptions = {
		responsive: true,
		maintainAspectRatio: true,
		scales: {
			yAxes: [
				{
					type: 'linear',
					display: true,
					gridLines: {
						drawOnChartArea: false
					},
					ticks: {
						suggestedMin: 0,
						suggestedMax: 100,
						fontSize: 15
					}
				}
			],
			xAxes: [
				{
					gridLines: {
						drawOnChartArea: false
					},
					ticks: {
						fontSize: 15
					}
				}
			]
		}
	};

	engagementChartColors = [
		{
			backgroundColor: 'rgba(131,153,196,0.5)',
			borderWidth: 5,
			borderColor: 'rgba(131,153,196,1)',
			pointBackgroundColor: 'rgba(131,153,196,0)',
			pointBorderColor: 'rgba(131,153,196,0)',
			pointHoverBackgroundColor: 'rgba(131,153,196,0)',
			pointHoverBorderColor: 'rgba(131,153,196,0)'
		},
		{
			backgroundColor: 'rgba(255,133,96,0.5)',
			borderWidth: 5,
			borderColor: 'rgba(255,133,96,1)',
			pointBackgroundColor: 'rgba(255,133,96,0)',
			pointBorderColor: 'rgba(255,133,96,0)',
			pointHoverBackgroundColor: 'rgba(255,133,96,0)',
			pointHoverBorderColor: 'rgba(255,133,96,0)'
		},
		{
			backgroundColor: 'rgba(168,184,205,0.5)',
			borderWidth: 5,
			borderColor: 'rgba(168,184,205,1)',
			pointBackgroundColor: 'rgba(168,184,205,0)',
			pointBorderColor: 'rgba(168,184,205,0)',
			pointHoverBackgroundColor: 'rgba(168,184,205,0)',
			pointHoverBorderColor: 'rgba(168,184,205,0)'
		}
	];

	engagementChartLabels = [
		'0 Sec',
		'1 Sec',
		'2 Sec',
		'3 Sec',
		'4 Sec',
		'5 Sec',
		'6 Sec',
		'7 Sec',
		'8 Sec',
		'9 Sec',
		'10 Sec',
		'11 Sec',
		'12 Sec',
		'13 Sec',
		'14 Sec',
		'15 Sec',
		'16 Sec',
		'17 Sec',
		'18 Sec',
		'19 Sec',
		'20 Sec'
	];

	engagementPieChartData = [];

	engagementPieChartLabels = ['Glanced or Unread', 'Skimmed', 'Read'];

	barChartOptions = {
		responsive: true,
		scales: { xAxes: [{}], yAxes: [{ ticks: { beginAtZero: true, max: 1000 } }] },
		plugins: {
			datalabels: {
				anchor: 'end',
				align: 'end'
			}
		}
	};

	ChartDataSets = [{ data: [], label: '', backgroundColor: '#A8B8CD', hoverBackgroundColor: '#A8B8CD' }];

	surveyHasResults = true;

	barChartColors = [
		{
			backgroundColor: '#A8B8CD',
			hoverBackgroundColor: '#A8B8CD'
		},
		{
			backgroundColor: '#8399c4',
			hoverBackgroundColor: '#8399c4'
		},
		{
			backgroundColor: '#6b7c9e',
			hoverBackgroundColor: '#6b7c9e'
		},
		{
			backgroundColor: '#FF8560',
			hoverBackgroundColor: '#FF8560'
		},
		{
			backgroundColor: '#1d1d1d',
			hoverBackgroundColor: '#1d1d1d'
		},
		{
			backgroundColor: '#3B3C3C',
			hoverBackgroundColor: '#3B3C3C'
		},
		{
			backgroundColor: '#526C8E',
			hoverBackgroundColor: '#526C8E'
		},
		{
			backgroundColor: '#405784',
			hoverBackgroundColor: '#405784'
		},
		{
			backgroundColor: '#3E4965',
			hoverBackgroundColor: '#3E4965'
		},
		{
			backgroundColor: '#D33100',
			hoverBackgroundColor: '#D33100'
		}
	];

	lineChartLabels = [];

	lineChartOptions = {
		layout: {
			padding: {
				left: 0,
				right: 10,
				top: 0,
				bottom: 0
			}
		},
		responsive: true,
		maintainAspectRatio: false,
		tooltips: {
			callbacks: {
				title: function (tooltipItem, chartData) {
					const date = new Date(tooltipItem[0].xLabel);
					const day = '00' + date.getDate();
					const monthIndex = '00' + (date.getMonth() + 1);
					const year = '00' + date.getFullYear();
					return monthIndex.substr(monthIndex.length - 2) + '/' + day.substr(day.length - 2) + '/' + year.substr(year.length - 2);
				}
			}
		},
		scales: {
			yAxes: [
				{
					id: 'y-axis-1',
					type: 'linear',
					position: 'left',
					display: true,
					gridLines: {
						drawOnChartArea: false,
						color: 'rgba(0,136,242,0.5)',
						zeroLineColor: 'rgba(0,136,242,0.5)'
					},
					ticks: {
						suggestedMin: 0,
						suggestedMax: 50,
						fontColor: '#8399c4',
						color: '#8399c4',
						fontSize: 15,
						beginAtZero: true
					}
				},
				{
					id: 'y-axis-2',
					type: 'linear',
					position: 'right',
					display: true,
					gridLines: {
						drawOnChartArea: false,
						color: 'rgba(255,90,94,0.5)',
						zeroLineColor: 'rgba(255,90,94,0.5)'
					},
					ticks: {
						suggestedMin: 0,
						suggestedMax: 10,
						fontColor: '#ff8560',
						color: '#ff8560',
						fontSize: 15,
						beginAtZero: true
					}
				}
			],
			xAxes: [
				{
					type: 'time',
					time: {
						displayFormats: {
							minute: 'MM/DD/YYYY hh:mm A',
							hour: 'MM/DD/YYYY hh:mm A',
							day: 'MM/DD/YYYY',
							week: 'MM/DD/YYYY'
						}
					},
					gridLines: {
						drawOnChartArea: false
					}
				}
			]
		}
	};

	lineChartColors = [
		{
			backgroundColor: 'rgba(131,153,196,0)',
			borderWidth: 3,
			borderColor: 'rgba(131,153,196,1)',
			pointBackgroundColor: 'rgba(131,153,196,1)',
			pointBorderColor: 'rgba(131,153,196,1)',
			pointBorderWidth: '4',
			pointHoverRadius: '6',
			pointHoverBackgroundColor: 'rgba(131,153,196,1)',
			pointHoverBorderColor: 'rgba(131,153,196,1)'
		},
		{
			backgroundColor: 'rgba(255,133,96,0)',
			borderWidth: 3,
			borderColor: 'rgba(255,133,96,1)',
			pointBackgroundColor: 'rgba(255,133,96,1)',
			pointBorderColor: 'rgba(255,133,96,1)',
			pointBorderWidth: '4',
			pointHoverRadius: '6',
			pointHoverBackgroundColor: 'rgba(255,133,96,1)',
			pointHoverBorderColor: 'rgba(255,133,96,1)'
		}
	];

	enviromentChartData = [0, 0, 0, 0, 0, 0];

	mobileChartData = [0, 0, 0, 0];

	webmailChartData = [0, 0, 0, 0, 0, 0, 0];

	statesOpens = {};

	statesClicks = {};

	countriesOpens = {};

	countriesClicks = {};

	enviromentChartLabels = ['Mobile', 'Desktop', 'Webmail', 'Gmail', 'Yahoo!', 'Others'];

	mobileChartLabels = ['iPhone', 'iPad', 'Android', 'Others'];

	webmailChartLabels = ['Outlook.com', 'GMX', 'iCloud', 'Xfinity', 'Verizon', 'GoDaddy', 'Others'];

	doughnutChartColors: any[] = [
		{
			backgroundColor: [
				'#8399c4', //blue
				'#ff8560', //orange
				'#a8b8cd', //lightblue
				'#9eb5a8', //green
				'#6b7c9e', //darkblue
				'#1d1d1d', //darkgray
				'#bbb7ed', //violet
				'#FFD4FC', //pink
				'#a8a9ac' //gray
			]
		}
	];

	doughnutChartOptions: any;
	joinedSubscription: Subscription;
	defaultIcon = 'fa fa-exclamation-circle';

	constructor(
		private component: ComponentService,
		private route: ActivatedRoute,
		private overlay: OverlayService,
		private auth: AuthService,
		private datePipe: DatePipe,
		private chartsService: ChartsService,
		private maintenance: MaintenanceService
	) {
		const date = new Date();
		const today = date.setDate(date.getDate());
		const last90 = date.setDate(date.getDate() - 90);
		const fromBigQuery = new Date('09/01/2016');

		this.fromDate = {
			val: new Date(last90),
			min: new Date(fromBigQuery),
			max: new Date(today)
		};
		this.toDate = {
			val: new Date(today),
			min: new Date(fromBigQuery),
			max: new Date(today)
		};
	}

	ngOnInit() {
		this.componentID = this.route.snapshot.params['componentID'];

		let suportedComponents$ = this.component.getSupportedComponents();
		let componentData$ = this.component.getComponentData(this.componentID);

		this.joinedSubscription = forkJoin([componentData$, suportedComponents$]).subscribe(
			(results) => {
				const componentDataResults = results[0];
				const suportedComponentsResults = results[1];

				this.componentData = componentDataResults.data;
				this.codesCSVButtonText = this.componentData.config.type === 53 ? this.barcodesCSVButtonText : this.couponCSVButtonText;
				this.createdTime = componentDataResults.data.createdAt;
				this.modifiedTime = componentDataResults.data.updatedAt;

				const supportedcomponentItem = suportedComponentsResults.data.find((data) => {
					return data.type === this.componentData.config.type;
				});

				this.componentData.icon =
					supportedcomponentItem && supportedcomponentItem.icon ? supportedcomponentItem.icon : this.defaultIcon;

				if (this.componentData.config.type === 52) {
					this.getSurveyData();
				}
			},
			(err) => {
				this.maintenance.serverMaintenance(err);
			}
		);

		this.getReportData();
		this.doughnutChartOptions = this.chartsService.getChartPointsInPercents();
		window.scrollTo(0, 0);
	}

	ngOnDestroy() {
		this.joinedSubscription.unsubscribe();
	}

	updateFilter() {
		if (this.componentData.config.type === 52) {
			this.getSurveyData();
		}
		this.getReportData();
	}

	getReportData() {
		const fromSS = Number(this.datePipe.transform(this.fromDate.val, 'yMMdd'));
		const toSS = Number(this.datePipe.transform(this.toDate.val, 'yMMdd'));

		this.component.getComponentReport(this.componentID, fromSS, toSS, this.dpid).subscribe((response: CreatorFrontApi) => {
			this.overlay.updateOverlay(false);
			if (response && response.status) {
				if (!response.data.empty) {
					if (
						response &&
						response.data &&
						Object.keys(response.data).length &&
						(response.data.totalOpens || response.data.totalClicks)
					) {
						this.reportData = response.data;
					} else {
						this.reportingDataEmpty();
					}
				} else {
					this.reportingDataEmpty();
				}
			} else {
				this.reportingDataEmpty();
			}

			this.isReportDataEmpty = this.reportData ? Boolean(Object.keys(this.reportData).length === 0) : false;
			if (!this.isReportDataEmpty) {
				this.processData();
			}
		});
	}

	reportingDataEmpty() {
		this.reportData = {};
		this.overlay.updateOverlay(true, this.noResultsError, 'alert');
	}

	getSurveyData() {
		const fromSS = Number(this.datePipe.transform(this.fromDate.val, 'yMMdd'));
		const toSS = Number(this.datePipe.transform(this.toDate.val, 'yMMdd'));

		this.surveyHasResults = false;
		this.component
			.getSurveyReport(this.componentID, fromSS, toSS, this.dpid, this.auth.getUser().id)
			.subscribe((response: CreatorFrontApi) => {
				if (response && response.status) {
					if (!response.data.empty && response.data.length) {
						this.surveyData = response && response.data && Object.keys(response.data).length ? response.data : {};
						this.surveyHasResults = true;
					} else {
						this.surveyData = [];
						this.surveyHasResults = false;
					}
				} else {
					this.surveyData = [];
					this.surveyHasResults = false;
				}

				this.processSurveyData();
			});
	}

	processData() {
		// line chart data
		this.lineChartLabels = [];
		this.lineChartData[0].data = [];
		this.lineChartData[1].data = [];
		const d = new Date(this.toDate.val);
		// d.setUTCDate(d.getDate());
		// d.setUTCDate(d.getDate() );
		const f = new Date(this.fromDate.val);
		f.setUTCDate(f.getDate() - 1);
		const oneDay = 24 * 60 * 60 * 1000;
		const diff = Math.round(Math.abs((d.getTime() - f.getTime()) / oneDay));
		let maxOpens = 0;
		let maxClicks = 0;
		d.setUTCHours(0, 0, 0, 0);
		this.opensData.length = 0;
		this.clicksData.length = 0;

		for (let i = 1; i <= diff; i++) {
			var opensClicksDates: Date = new Date(this.toDate.val);
			opensClicksDates.setUTCHours(0, 0, 0, 0);
			const timeStamp = opensClicksDates.getTime() - (i - 1) * oneDay;
			const timeStampLabel = opensClicksDates.getTime() - (i - 2) * oneDay;

			this.lineChartLabels.push(timeStampLabel);

			const opens =
				this.reportData && Object.keys(this.reportData).length && this.reportData.opensByDate[timeStamp]
					? this.reportData.opensByDate[timeStamp]
					: 0;

			const clicks =
				this.reportData && Object.keys(this.reportData).length && this.reportData.clicksByDate[timeStamp]
					? this.reportData.clicksByDate[timeStamp]
					: 0;

			this.opensData.push(opens && opens.length ? opens : null);
			this.clicksData.push(clicks && clicks.length ? clicks : null);

			this.lineChartData[0].data.push(opens && opens.length ? opens : null);
			this.lineChartData[1].data.push(clicks && clicks.length ? clicks : null);

			if (+opens > maxOpens) {
				maxOpens = +opens;
			}
			if (+clicks > maxClicks) {
				maxClicks = +clicks;
			}
		}

		let opensReverse = this.opensData.reverse();
		let clicksReverse = this.clicksData.reverse();

		for (let i = 0; i < diff; i++) {
			clicksReverse[i] = clicksReverse[i] && clicksReverse[i].length ? clicksReverse[i] : clicksReverse[i - 1] != null ? 0 : null;
			opensReverse[i] = opensReverse[i] && opensReverse[i].length ? opensReverse[i] : opensReverse[i - 1] != null ? 0 : null;
		}

		this.opensData = opensReverse.reverse();
		this.clicksData = clicksReverse.reverse();

		this.lineChartData[0].data = [...this.opensData];
		this.lineChartData[1].data = [...this.clicksData];

		this.lineChartOptions.scales.yAxes[0].ticks.suggestedMax = Math.ceil(maxOpens * 1.1);
		this.lineChartOptions.scales.yAxes[1].ticks.suggestedMax = Math.ceil(maxClicks * 1.1);

		if (this.showOpens == false && this.showClicks == true) {
			this.lineChartData[0].data = [];
		} else if (this.showClicks == false && this.showOpens == true) {
			this.lineChartData[1].data = [];
		} else if (this.showClicks == false && this.showOpens == false) {
			this.lineChartData[0].data = [];
			this.lineChartData[1].data = [];
		}

		if (this.componentData.config.type == 25) {
			this.lineChartOptions.scales.yAxes[1].display = false;
			this.lineChartData[1].data = [];
		}

		// Opens by Environment
		this.enviromentChartData = [
			+this.reportData.mobile_opens,
			+this.reportData.desktop_opens,
			+this.reportData.web_opens,
			+this.reportData.gmail_opens,
			+this.reportData.yahoo,
			+this.reportData.unknown_opens
		];
		// Mobile Devices
		this.mobileChartData = [
			+this.reportData.iphone_opens,
			+this.reportData.ipad_opens,
			+this.reportData.android_opens,
			+this.reportData.mobile_others
		];
		// WebMail Clients
		this.webmailChartData = [
			+this.reportData.outlook_com,
			+this.reportData.gmx,
			+this.reportData.icloud,
			+this.reportData.comcast,
			+this.reportData.verizon,
			+this.reportData.godaddy,
			+this.reportData.web_others
		];

		// Geo data
		for (const location in this.statesOpens) {
			delete this.statesOpens[location];
		}
		for (const location in this.statesClicks) {
			delete this.statesClicks[location];
		}
		for (const location in this.countriesOpens) {
			delete this.countriesOpens[location];
		}
		for (const location in this.countriesClicks) {
			delete this.countriesClicks[location];
		}

		for (const i in this.reportData.statesOpens) {
			if (this.reportData.statesOpens.hasOwnProperty(i)) {
				this.statesOpens[i] = this.reportData.statesOpens[i][1];
			}
		}
		for (const i in this.reportData.statesClicks) {
			if (this.reportData.statesClicks.hasOwnProperty(i)) {
				this.statesClicks[i] = this.reportData.statesClicks[i][1];
			}
		}
		for (const i in this.reportData.countriesOpens) {
			if (this.reportData.countriesOpens.hasOwnProperty(i)) {
				this.countriesOpens[i] = this.reportData.countriesOpens[i][1];
			}
		}
		for (const i in this.reportData.countriesClicks) {
			if (this.reportData.countriesClicks.hasOwnProperty(i)) {
				this.countriesClicks[i] = this.reportData.countriesClicks[i][1];
			}
		}

		this.updateMap();

		if (this.componentData.config.type === 25) {
			this.processTimeInEmailData();
		}

		this.chart.chart.update();
	}

	processTimeInEmailData() {
		let _engagementChartData = { ...this.engagementChartData };

		_engagementChartData[0].data = [];
		_engagementChartData[1].data = [];
		_engagementChartData[2].data = [];

		let i = 100;
		_engagementChartData[0].data.push(i);
		_engagementChartData[1].data.push(null);
		_engagementChartData[2].data.push(null);

		i -= +((this.reportData.unread * 100) / (this.reportData.unread + this.reportData.skimmed + this.reportData.read));
		_engagementChartData[0].data.push((100 - (100 - i) / 2).toFixed(2));
		_engagementChartData[0].data.push(i.toFixed(2));
		_engagementChartData[1].data.push(null);
		_engagementChartData[1].data.push(i.toFixed(2));
		_engagementChartData[2].data.push(null);
		_engagementChartData[2].data.push(null);

		const jump = (this.reportData.skimmed * 100) / (this.reportData.unread + this.reportData.skimmed + this.reportData.read) / 5;

		for (let ind = 0; ind < 5; ind += 1) {
			i -= jump;
			_engagementChartData[0].data.push(null);
			_engagementChartData[1].data.push(i.toFixed(2));
			if (ind !== 4) {
				_engagementChartData[2].data.push(null);
			}
		}

		for (let ind = 0; ind < 14; ind += 1) {
			_engagementChartData[0].data.push(null);
			_engagementChartData[1].data.push(null);
			_engagementChartData[2].data.push(
				Math.round(
					(this.reportData.read * 100) / (this.reportData.unread + this.reportData.skimmed + this.reportData.read)
				).toFixed(2)
			);
		}

		const _engagementPieChartData = [this.reportData.unread, this.reportData.skimmed, this.reportData.read];
		this.engagementPieChartData = _engagementPieChartData;
	}

	processSurveyData() {
		this.ChartDataSets = [];
		this.surveyTotalResponses = 0;

		if (this.surveyData.length) {
			this.surveyData.forEach((element, index) => {
				this.surveyTotalResponses += element.total;
				this.ChartDataSets.push({
					data: [element.total],
					label: element.p1,
					backgroundColor: this.barChartColors[index].backgroundColor,
					hoverBackgroundColor: this.barChartColors[index].hoverBackgroundColor
				});
			});

			this.chart.chart.data.datasets = this.ChartDataSets;

			const highestTotal = Math.max(...this.surveyData.map((item) => item.total), 0);

			this.barChartOptions = {
				responsive: true,
				scales: { xAxes: [{}], yAxes: [{ ticks: { beginAtZero: true, max: Math.ceil((highestTotal * 1.1) / 10) * 10 } }] },
				plugins: {
					datalabels: {
						anchor: 'end',
						align: 'end'
					}
				}
			};
		} else {
			this.chart.chart.data.datasets = [{ data: [0], label: '', backgroundColor: '#ffffff', hoverBackgroundColor: '#ffffff' }];
		}
		this.chart.chart.update();
	}

	updateMap() {
		if (this.reportData && !Object.keys(this.reportData).length) {
			this.geoChart.data = {};
			this.geotableData = [];
			return false;
		}

		switch (this.geoChart.dataType) {
			case 'Opens':
				this.geoChart.colors = ['#adc9ff', '#8399c4'];
				if (this.geoChart.mapType === 'us_aea') {
					this.geoChart.data = this.statesOpens;
				} else {
					this.geoChart.data = this.countriesOpens;
				}
				break;
			case 'Clicks':
				this.geoChart.colors = ['#ffcdbe', '#ff8560'];
				if (this.geoChart.mapType === 'us_aea') {
					this.geoChart.data = this.statesClicks;
				} else {
					this.geoChart.data = this.countriesClicks;
				}
				break;
		}
		if (this.geoChart.mapType === 'us_aea') {
			this.geotableData = Object.keys(this.statesOpens).map((key) => {
				return {
					key: key,
					name: this.reportData.statesOpens[key][0],
					opens: this.reportData.statesOpens[key][1],
					clicks: this.reportData.statesClicks[key][1]
				};
			});
		} else {
			this.geotableData = Object.keys(this.countriesOpens).map((key) => {
				return {
					place: key,
					name: this.reportData.countriesOpens[key][0],
					opens: this.reportData.countriesOpens[key][1],
					clicks: typeof this.reportData.countriesClicks[key] === 'undefined' ? 0 : this.reportData.countriesClicks[key][1]
				};
			});
		}
	}

	chartClicked(e: any): void {
		// console.log(e);
	}

	chartHovered(e: any): void {
		// console.log(e);
	}

	dateChange(field, newVal) {
		if (field === 'fromDate') {
			this.fromDate.val = newVal;
			this.toDate.min = newVal;
		}
		if (field === 'toDate') {
			this.toDate.val = newVal;
			this.fromDate.max = newVal;
		}
		if (this.componentData.config.type === 52) {
			this.getSurveyData();
		}
		this.getReportData();
	}

	showOpensClicksChange() {
		const _lineChartData = JSON.parse(JSON.stringify(this.lineChartData));
		if (this.showOpens) {
			_lineChartData[0].data = this.opensData;
		} else {
			_lineChartData[0].data = [];
		}
		if (this.showClicks) {
			_lineChartData[1].data = this.clicksData;
		} else {
			_lineChartData[1].data = [];
		}
		this.lineChartData = _lineChartData;
		this.chart.chart.update();
	}

	exportToPDF(componentID, fromDate, toDate, dpid) {
		this.generatingPDF = true;
		this.pdfBTNText = 'Processing...';
		document.body.style.cursor = 'progress';
		const fromTime = Number(this.datePipe.transform(this.fromDate.val, 'yMMddHHmm'));
		const toTime = Number(this.datePipe.transform(this.toDate.val, 'yMMddHHmm'));
		const userId = this.auth.getUser().id;

		let url = `${environment.newApiURL}/report/pdf/component/${componentID}?id=${componentID}&fromDate=${fromTime}&dateTo=${toTime}&user=${userId}`;
		if (dpid && dpid !== 'all') {
			url += '&dpid=' + dpid;
		}

		const iframe = document.createElement('iframe');
		iframe.style.width = '1px';
		iframe.style.height = '1px';
		iframe.src = url;
		document.body.appendChild(iframe);
		setTimeout(() => {
			this.generatingPDF = false;
			this.pdfBTNText = 'Export to PDF';
			document.body.style.cursor = 'default';
		}, 15000);
	}

	exportToCSV(CSVType): void {
		let csvContent = 'data:text/csv;charset=utf-8,';
		let data;
		const filename = `${this.componentData.name} ${CSVType} ${this.datePipe.transform(
			this.fromDate.val,
			'yMMdd'
		)}-${this.datePipe.transform(this.toDate.val, 'yMMdd')}.csv`;

		switch (CSVType) {
			case 'openClicks':
				data = this.getOpensClicksCSVData();
				break;
			case 'emailClients':
				data = this.getEmailClientsCSVData();
				break;
			case 'geoReport':
				data = this.getGeoCSVData();
				break;
		}
		for (const row of data) {
			csvContent += row.join(',');
			csvContent += `\n`;
		}

		const encodedUri = encodeURI(csvContent);
		const link = document.createElement('a');
		link.setAttribute('href', encodedUri);
		link.setAttribute('download', filename);
		document.body.appendChild(link);

		link.click();
	}

	exportSurveyToCSV(): void {
		const fromSS = Number(this.datePipe.transform(this.fromDate.val, 'yMMdd'));
		const toSS = Number(this.datePipe.transform(this.toDate.val, 'yMMdd'));

		if (fromSS > toSS) {
			this.overlay.updateOverlay(true, `No results found for this query! Please change the filter parameters.`, 'alert');
		} else if (this.surveyTotalResponses > this.maxSurveyResponses) {
			this.overlay.updateOverlay(
				true,
				`Maximum number of results exported to the CSV is ${this.maxSurveyResponses
					.toString()
					.split('')
					.reverse()
					.join('')
					.match(/.{1,3}/g)
					.join(',')
					.split('')
					.reverse()
					.join('')}. You are attempting to export ${this.surveyTotalResponses
					.toString()
					.split('')
					.reverse()
					.join('')
					.match(/.{1,3}/g)
					.join(',')
					.split('')
					.reverse()
					.join(
						''
					)} results. Please change the filter parameters. Please contact dmsupport@optimove.com if you need additional help.`,
				'alert'
			);
		} else {
			this.generatingSurveyCSV = true;
			this.surveyCSVButtonText = 'Processing...';
			setTimeout(() => {
				this.generatingSurveyCSV = false;
				this.surveyCSVButtonText = 'Export Individual Responses To CSV';
			}, 15000);

			const filename = encodeURIComponent(
				`${this.componentData.name} survey_responses ${this.datePipe.transform(
					this.fromDate.val,
					'yMMdd'
				)}-${this.datePipe.transform(this.toDate.val, 'yMMdd')}.csv`
			);

			let url = `${environment.newApiURL}/report/survey/csv/component/${this.componentID}?&id=${
				this.componentID
			}&fromDate=${fromSS}&dateTo=${toSS}&filename=${filename}&user=${this.auth.getUser().id}`;

			url = this.dpid && this.dpid !== 'all' ? `${url}&dpid=${this.dpid}` : url;

			const link = document.createElement('a');
			link.setAttribute('href', url);
			link.setAttribute('download', filename);
			document.body.appendChild(link);

			link.click();
		}
	}

	exportCodesToCSV(): void {
		this.generatingCodesCSV = true;
		this.codesCSVButtonText = 'Processing...';
		setTimeout(() => {
			this.generatingCodesCSV = false;
			this.codesCSVButtonText = this.componentData.config.type === 53 ? this.barcodesCSVButtonText : this.couponCSVButtonText;
		}, 15000);

		const filename = encodeURIComponent(
			`${this.componentData.name} Assigned Codes ${this.datePipe.transform(Date.now(), 'yMMdd')}.csv`
		);
		let url = `${environment.newApiURL}/report/coupon/csv/component/${this.componentID}?&tenant_id=${this.componentData.config.tenant_id}&filename=${filename}`;
		const link = document.createElement('a');
		link.setAttribute('href', url);
		link.setAttribute('download', filename);
		document.body.appendChild(link);
		link.click();
	}

	getOpensClicksCSVData() {
		const csvData = [];
		let row;

		for (const i in this.reportData.opensByDate) {
			if (this.reportData.opensByDate.hasOwnProperty(i)) {
				const adjustDay = parseInt(i) + 86400000;
				if (this.componentData.config.type === 25) {
					row = [
						this.datePipe.transform(+adjustDay, 'MM/dd/y'),
						this.datePipe.transform(+i, 'hh:mm a'),
						this.reportData.opensByDate[i]
					];
				} else {
					row = [
						this.datePipe.transform(+adjustDay, 'MM/dd/y'),
						this.datePipe.transform(+i, 'hh:mm a'),
						this.reportData.opensByDate[i],
						this.reportData.clicksByDate[i],
						Math.round((this.reportData.clicksByDate[i] * 100) / this.reportData.opensByDate[i]) + '%'
					];
				}
				csvData.unshift(row);
			}
		}
		if (this.componentData.config.type === 25) {
			row = ['Date', 'Hour', 'Opens'];
		} else {
			row = ['Date', 'Hour', 'Opens', 'Clicks', 'CTR'];
		}
		csvData.unshift(row);
		return csvData;
	}

	getEmailClientsCSVData() {
		const csvData = [];
		csvData.push(['Opens by Environment', ' ', ' ']);
		csvData.push([' ', ' ', ' ']);
		csvData.push(['Environment', 'Opens', 'Opens in %']);
		csvData.push(['Mobile', this.reportData.mobile_opens, (this.reportData.mobile_opens / this.reportData.totalOpens) * 100]);
		csvData.push(['WebMail', this.reportData.web_opens, (this.reportData.web_opens / this.reportData.totalOpens) * 100]);
		csvData.push(['Desktop', this.reportData.desktop_opens, (this.reportData.desktop_opens / this.reportData.totalOpens) * 100]);
		csvData.push(['Gmail', this.reportData.gmail_opens, (this.reportData.gmail_opens / this.reportData.totalOpens) * 100]);
		csvData.push(['Yahoo!', this.reportData.yahoo, (this.reportData.yahoo / this.reportData.totalOpens) * 100]);
		csvData.push(['Others', this.reportData.unknown_opens, (this.reportData.unknown_opens / this.reportData.totalOpens) * 100]);
		csvData.push(['Total', this.reportData.totalOpens, '100']);
		csvData.push([' ', ' ', ' ']);
		csvData.push([' ', ' ', ' ']);
		csvData.push(['Mobile Devices', ' ', ' ']);
		csvData.push([' ', ' ', ' ']);
		csvData.push(['Device', 'Opens', 'Opens in %']);
		csvData.push(['iPhone', this.reportData.iphone_opens, (this.reportData.iphone_opens / this.reportData.totalOpens) * 100]);
		csvData.push(['iPad', this.reportData.ipad_opens, (this.reportData.ipad_opens / this.reportData.totalOpens) * 100]);
		csvData.push(['Android', this.reportData.android_opens, (this.reportData.android_opens / this.reportData.totalOpens) * 100]);
		csvData.push(['Others', this.reportData.mobile_others, (this.reportData.mobile_others / this.reportData.totalOpens) * 100]);
		csvData.push(['Total', this.reportData.mobile_opens, (this.reportData.mobile_opens / this.reportData.totalOpens) * 100]);

		csvData.push([' ', ' ', ' ']);
		csvData.push([' ', ' ', ' ']);
		csvData.push(['WebMail Clients', ' ', ' ']);
		csvData.push([' ', ' ', ' ']);
		csvData.push(['Client', 'Opens', 'Opens in %']);
		csvData.push(['Outlook.com', this.reportData.outlook_com, (this.reportData.outlook_com / this.reportData.totalOpens) * 100]);
		csvData.push(['GMX', this.reportData.gmx, (this.reportData.gmx / this.reportData.totalOpens) * 100]);
		csvData.push(['iCloud', this.reportData.icloud, (this.reportData.icloud / this.reportData.totalOpens) * 100]);
		csvData.push(['Xfinity', this.reportData.comcast, (this.reportData.comcast / this.reportData.totalOpens) * 100]);
		csvData.push(['Verizon', this.reportData.verizon, (this.reportData.verizon / this.reportData.totalOpens) * 100]);
		csvData.push(['GoDaddy', this.reportData.godaddy, (this.reportData.godaddy / this.reportData.totalOpens) * 100]);
		csvData.push(['Others', this.reportData.web_others, (this.reportData.web_others / this.reportData.totalOpens) * 100]);
		csvData.push(['Total', this.reportData.web_opens, (this.reportData.web_opens / this.reportData.totalOpens) * 100]);
		csvData.push([' ', ' ', ' ']);
		csvData.push([' ', ' ', ' ']);
		csvData.push(['Desktop  Clients', ' ', ' ']);
		csvData.push([' ', ' ', ' ']);
		csvData.push(['Client', 'Opens', 'Opens in %']);
		csvData.push(['Outlook', this.reportData.outlook, (this.reportData.outlook / this.reportData.totalOpens) * 100]);
		csvData.push(['Apple Mail', this.reportData.apple_mail, (this.reportData.apple_mail / this.reportData.totalOpens) * 100]);
		csvData.push(['Thunderbird', this.reportData.thunderbird, (this.reportData.thunderbird / this.reportData.totalOpens) * 100]);
		csvData.push(['Others', this.reportData.desktop_others, (this.reportData.desktop_others / this.reportData.totalOpens) * 100]);
		csvData.push(['Total', this.reportData.desktop_opens, (this.reportData.desktop_opens / this.reportData.totalOpens) * 100]);

		return csvData;
	}

	getGeoCSVData() {
		const csvData = [];
		let row;
		if (this.componentData.config.type === 25) {
			row = ['Country/State', 'Opens', '% of Opens'];
		} else {
			row = ['Country/State', 'Opens', '% of Opens', 'Clicks', '% of Clicks'];
		}
		csvData.push(row);
		let totalOpens = this.reportData.totalOpens;
		let totalClicks = this.reportData.totalClicks;
		if (this.geoChart.mapType === 'us_aea') {
			for (const i in this.reportData.statesOpens) {
				if (this.reportData.statesOpens.hasOwnProperty(i)) {
					if (this.componentData.config.type === 25) {
						row = [
							this.reportData.statesOpens[i][0],
							this.reportData.statesOpens[i][1],
							Math.round((this.reportData.statesOpens[i][1] * 100) / this.reportData.totalOpens) + '%'
						];
					} else {
						row = [
							this.reportData.statesOpens[i][0],
							this.reportData.statesOpens[i][1],
							Math.round((this.reportData.statesOpens[i][1] * 100) / this.reportData.totalOpens) + '%',
							this.reportData.statesClicks[i][1],
							Math.round((this.reportData.statesClicks[i][1] * 100) / this.reportData.totalClicks) + '%'
						];
					}
					totalOpens -= Math.round(+this.reportData.statesOpens[i][1]);
					totalClicks -= Math.round(+this.reportData.statesClicks[i][1]);
					csvData.push(row);
				}
			}
		} else {
			for (const i in this.reportData.countriesOpens) {
				if (this.reportData.countriesOpens.hasOwnProperty(i)) {
					if (this.componentData.config.type === 25) {
						row = [
							this.reportData.countriesOpens[i][0],
							this.reportData.countriesOpens[i][1],
							Math.round((this.reportData.countriesOpens[i][1] * 100) / this.reportData.totalOpens) + '%'
						];
					} else {
						row = [
							this.reportData.countriesOpens[i][0],
							this.reportData.countriesOpens[i][1],
							Math.round((this.reportData.countriesOpens[i][1] * 100) / this.reportData.totalOpens) + '%',
							this.reportData.countriesClicks[i][1],
							Math.round((this.reportData.countriesClicks[i][1] * 100) / this.reportData.totalClicks) + '%'
						];
					}
					totalOpens -= Math.round(+this.reportData.countriesOpens[i][1]);
					totalClicks -= Math.round(+this.reportData.countriesClicks[i][1]);
					csvData.push(row);
				}
			}
		}

		if (totalOpens >= 0 && totalClicks >= 0) {
			csvData.push([
				'Unidentified',
				totalOpens,
				Math.round((totalOpens * 100) / this.reportData.totalOpens) + '%',
				totalClicks,
				Math.round((totalClicks * 100) / this.reportData.totalClicks) + '%'
			]);
		}
		return csvData;
	}
}
